import packageInfo from '../../package.json';

export const environment = {
	appVersion: packageInfo.version,
	production: false,
	API_DOMAIN: 'https://back-wipa.betacore.pro',
	API_DOMAIN_FLAG: 'https://flag-wipa.betacore.pro',
	WRITE_ACCESS_KEY: '948201746382915',
	WEBSOCKET_URL: 'wss://back-notification-wipa.betacore.pro/notifications',
	googleMapsApiKey: 'AIzaSyCm5KxfafwEaEu9U8SLzIoMo5kgWK3nlTg',
	googlePlay: 'https://play.google.com/store/apps/details?id=com.wipa.passenger',
	appStore: 'https://apps.apple.com/co/app/wipa-pasajero/id6754669799',
	SERVICES: {
		FLAGS: `/api/v1`,
		SECURITY: `/api/v1`,
		DRIVERS: `/api/v1`,
		PASSENGERS: `/api/v1`,
		BRANDS: `/api/v1/vehicle-brands`,
		CATEGORY: `/api/v1/vehicle-category`,
		VEHICLES: `/api/v1`,
		DOCUMENT: `/api/v1`,
		LENGUAGE: `/api/v1`,
		ADMIN: `/api/v1/`,
		ENTERPRISE: `/api/v1/`,
		PARAMETERS: `/api/v1`,
		COUPON: `/api/v1/coupons`,
		IDENTIFICATION_TYPE: `/api/v1`,
		SERVICES_GESTION: `/api/v1`,
		GENDER: `/api/v1`,
		RATES: `/api/v1`,
		PRE_OPERATIONAL: `/api/v1`,
		FUEC_CONFIG: `/api/v1/fuec/fuec-config`,
		DASHBOARD: `/api/v1/dashboards`,
		PUSH_NOTIFICATIONS: `/api/v1/push-notifications`,
		USER_NOTIFICATIONS: `/api/v1/user/notifications`,
		LICENSES: `/api/v1/licenses`,
		BENEFICIARIES: `/api/v1/`,
		FUEC: `/api/v1/fuec`,
		APP_VERSIONS: `/api/v1/app-versions`,
		HELPLINES: `/api/v1`,
		PROMOTIONS: `/api/v1`,
		LEGAL_REPRESENTATIVES_FUEC_TOURISM: `/api/v1/fuec/legal-representatives-tourism`
	}
};
